import React from 'react';
import { Slideshow, slideTypes, slideTextTypes } from 'abbot-core';
import img1 from '../../assets/images/U1-T2-3-1a.svg';
import img2 from '../../assets/images/U1-T2-3-1b.svg';
import img3 from '../../assets/images/U1-T2-3-1c.svg';
import img4 from '../../assets/images/U1-T2-3-1d.svg';
import img5 from '../../assets/images/U1-T2-3-1e.svg';
import voAudio1 from '../../assets/vo/U1-T2-3-1a.mp3';
import voAudio2 from '../../assets/vo/U1-T2-3-1b.mp3';
import voAudio3 from '../../assets/vo/U1-T2-3-1c.mp3';
import voAudio4 from '../../assets/vo/U1-T2-3-1d.mp3';
import voAudio5 from '../../assets/vo/U1-T2-3-1e.mp3';

const slides = [
  {
    SlideType: slideTypes.HorizontalPan,
    panDirection: 'right',
    duration: 7,
    image: img1,
    imageAltText: '',
    text: {
      type: slideTextTypes.BottomText,
      text: `Make the most nutritious food choices possible.`
    },
    vo: {
      sources: [
        {
          src: voAudio1
        }
      ],
      transcript: (
        <p>
          Let’s go over what you’ve learned. Making the most nutritious food choices possible is essential for your health now and in the future.
        </p>
      )
    }
  },
  {
    SlideType: slideTypes.HorizontalPan,
    panDirection: 'left',
    duration: 6.2,
    image: img2,
    imageAltText: '',
    vo: {
      sources: [
        {
          src: voAudio2
        }
      ],
      transcript: (
        <p>
          Eating nutritious food fuels your body, can lead to stronger bones and muscles, and can give you increased energy.
        </p>
      )
    }
  },
  {
    SlideType: slideTypes.HorizontalPan,
    panDirection: 'right',
    duration: 8.4,
    image: img3,
    imageAltText: '',
    vo: {
      sources: [
        {
          src: voAudio3
        }
      ],
      transcript: (
        <p>
          It is important to eat a balance of all the food groups and to pay attention to things like serving size, sodium, sugar, and fat when you’re reading nutrition labels.
        </p>
      )
    }
  },
  {
    SlideType: slideTypes.HorizontalPan,
    panDirection: 'left',
    duration: 10.2,
    image: img4,
    imageAltText: '',
    text: {
      type: slideTextTypes.BottomText,
      text: `Nutritious food choices can reduce your risk of developing certain NCDs.`
    },
    vo: {
      sources: [
        {
          src: voAudio4
        }
      ],
      transcript: (
        <p>
          Making the most nutritious food choices possible can help reduce the risk of developing certain noncommunicable diseases, like type 2 diabetes, high blood pressure, and heart disease.
        </p>
      )
    }
  },
  {
    SlideType: slideTypes.HorizontalPan,
    panDirection: 'left',
    duration: 8,
    image: img5,
    imageAltText: '',
    vo: {
      sources: [
        {
          src: voAudio5
        }
      ],
      transcript: (
        <p>
          Even if you can’t control what food is available, understanding what’s in the food and how your body uses it can help you make the most nutritious food choices possible.
        </p>
      )
    }
  }
];

export default {
  title: 'Wrap Up',
  path: '/reflect/wrap-up',
  content: <Slideshow slides={slides} />
};



// WEBPACK FOOTER //
// ./src/data/reflect/WrapUp.js